import { ReactElement } from "react";

import { useTranslation } from "@/v2/hooks/useTranslation";
import { FreeSpinsSyncResult } from "@/v2/types/FreeSpinsSync/FreeSpinsSyncResult.interface";

import { FreeSpinsRetrievalPanel } from "./FreeSpinsRetrievalPanel";

/** No game failed. Nothing found is a warning, not a success. */
export const FreeSpinsRetrievalSuccess = (props: FreeSpinsRetrievalSuccessProps): ReactElement => {
  const { result } = props;
  const { t } = useTranslation();

  if (result.valuesFound === 0) {
    return (
      <FreeSpinsRetrievalPanel type="warning">
        {t("free-spin.fs-retrieval-modal.nothing-found")}
      </FreeSpinsRetrievalPanel>
    );
  }

  return (
    <FreeSpinsRetrievalPanel type="success">
      {t("free-spin.fs-retrieval-modal.success", {
        valuesFound: result.valuesFound,
        valuesPublished: result.valuesPublished,
      })}
    </FreeSpinsRetrievalPanel>
  );
};

interface FreeSpinsRetrievalSuccessProps {
  result: FreeSpinsSyncResult;
}
